/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import React, { useState } from "react";
import { Location, navigate } from "@reach/router";
import { useQuery } from "@apollo/client";
import { Viewer } from "components/auth/types";
import { QueryInterestProfile, QueryInterestProfileVariables } from "types/gql-types";
import { ServerError } from "components/graphql-views";
import { CloseButton } from "components/haven-design/buttons";
import BatchActionsModal from "pages/dashboard/interests-batch-actions/batch-actions-modal";
import { QUERY_INTEREST_PROFILE } from "pages/dashboard/interests-profile/query";
import styles from "./slideout.module.css";
import { ApplicantProfileView } from "./index";

interface Props {
  path?: string;
  viewer: Viewer;
  onStar?: (id: string) => void;
  interestId?: string;
  listId: string;
  sendFullAppToInterestsEnabled: boolean;
}

const InterestProfileSlideout: React.FC<Props> = (props) => {
  const { viewer, onStar, interestId, sendFullAppToInterestsEnabled } = props;

  if (!interestId) {
    return null;
  }

  const [batchActionsModalFocusedAction, setBatchActionsModalFocusedAction] = useState();

  const queryInterestProfile = useQuery<QueryInterestProfile, QueryInterestProfileVariables>(
    QUERY_INTEREST_PROFILE,
    {
      fetchPolicy: "no-cache",
      variables: {
        interestId,
      },
    },
  );

  if (queryInterestProfile.loading) {
    return null;
  }

  if (
    queryInterestProfile.error ||
    !queryInterestProfile.data?.interest?.id ||
    !queryInterestProfile.data?.interest?.interestList
  ) {
    return <ServerError desc="There was a problem loading the page." />;
  }
  const {
    interest,
    interest: {
      id,
      householdMember0FirstName: firstName,
      householdMember0LastName: lastName,
      interestList: { id: listID, property },
      householdCount,
      householdGrossAnnualIncome,
      status: { name: status },
      user,
    },
  } = queryInterestProfile.data;

  const onSubmit = () =>
    new Promise<void>((resolve) => {
      resolve();
    });

  return (
    <Location>
      {(location) => (
        <div className={styles.slideout}>
          <CloseButton onClick={() => navigate("..")} />
          <div style={{ height: "100%" }}>
            <ApplicantProfileView
              onStar={() => onStar && onStar(interestId)}
              location={location}
              viewer={viewer}
              setBatchActionsModalFocusedAction={setBatchActionsModalFocusedAction}
              currentInterestID={id}
              interestListID={listID}
              householdMember0FirstName={firstName}
              householdMember0LastName={lastName}
              property={property}
              householdCount={householdCount}
              householdGrossAnnualIncome={householdGrossAnnualIncome}
              status={status}
              onSubmit={onSubmit}
              sendFullAppToInterestsEnabled={sendFullAppToInterestsEnabled}
              interest={interest}
              user={user}
            />
            <BatchActionsModal
              focusedAction={batchActionsModalFocusedAction}
              interestID={interestId}
              interestListID={listID}
              viewer={viewer}
              interest={interest}
              setBatchActionsModalFocusedAction={setBatchActionsModalFocusedAction}
            />
          </div>
        </div>
      )}
    </Location>
  );
};

export default InterestProfileSlideout;
